"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _lodash = require("lodash");
var _permission = _interopRequireDefault(require("../common/errors/permission"));
var _constants = require("../constants");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _enums = require("./enums");
var _util = _interopRequireDefault(require("./util"));
var _constants2 = require("./constants");
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * docs
 * https://sqbu-github.cisco.com/pages/WebExSquared/locus/guides/mute.html
 * https://confluence-eng-gpk2.cisco.com/conf/display/LOCUS/Hard+Mute+and+Audio+Privacy#HardMuteandAudioPrivacy-SelfMuteonEntry
 * https://confluence-eng-gpk2.cisco.com/conf/pages/viewpage.action?spaceKey=UC&title=WEBEX-124454%3A+UCF%3A+Hard+mute+support+for+Teams+joining+Webex+meeting
 * https://jira-eng-gpk2.cisco.com/jira/browse/SPARK-180867
 * https://jira-eng-gpk2.cisco.com/jira/browse/SPARK-393351
 */
/**
 * @description ControlsOptionsManager is responsible for handling the behavior of participant controls when somebody joins a meeting
 * @export
 * @private
 * @class Recording
 */
var ControlsOptionsManager = exports.default = /*#__PURE__*/function () {
  /**
   * @param {MeetingRequest} request
   * @param {Object} options
   * @constructor
   * @memberof ControlsOptionsManager
   */
  function ControlsOptionsManager(request, options) {
    (0, _classCallCheck2.default)(this, ControlsOptionsManager);
    /**
     * @instance
     * @type {MeetingRequest}
     * @private
     * @memberof ControlsOptionsManager
     */
    (0, _defineProperty2.default)(this, "request", void 0);
    /**
     * @instance
     * @type {Array}
     * @private
     * @memberof ControlsOptionsManager
     */
    (0, _defineProperty2.default)(this, "displayHints", []);
    /**
     * @instance
     * @type {string}
     * @private
     * @memberof ControlsOptionsManager
     */
    (0, _defineProperty2.default)(this, "locusUrl", void 0);
    this.initialize(request);
    this.set(options);
  }

  /**
   * @param {MeetingRequest} request
   * @returns {void}
   * @private
   * @memberof ControlsOptionsManager
   */
  (0, _createClass2.default)(ControlsOptionsManager, [{
    key: "initialize",
    value: function initialize(request) {
      this.request = request;
    }

    /**
     * @param {Object} options
     * @returns {void}
     * @public
     * @memberof ControlsOptionsManager
     */
  }, {
    key: "set",
    value: function set(options) {
      this.extract(options);
    }

    /**
     * @param {string} url
     * @returns {void}
     * @public
     * @memberof ControlsOptionsManager
     */
  }, {
    key: "setLocusUrl",
    value: function setLocusUrl(url) {
      this.locusUrl = url;
    }

    /**
     * @param {Array} hints
     * @returns {void}
     * @public
     * @memberof ControlsOptionsManager
     */
  }, {
    key: "setDisplayHints",
    value: function setDisplayHints(hints) {
      this.displayHints = hints;
    }

    /**
     * @returns {string}
     * @public
     * @memberof ControlsOptionsManager
     */
  }, {
    key: "getLocusUrl",
    value: function getLocusUrl() {
      return this.locusUrl;
    }

    /**
     * @returns {Array}
     * @public
     * @memberof ControlsOptionsManager
     */
  }, {
    key: "getDisplayHints",
    value: function getDisplayHints() {
      return this.displayHints;
    }

    /**
     * @param {Object} options
     * @returns {void}
     * @private
     * @memberof ControlsOptionsManager
     */
  }, {
    key: "extract",
    value: function extract(options) {
      this.setDisplayHints(options === null || options === void 0 ? void 0 : options.displayHints);
      this.setLocusUrl(options === null || options === void 0 ? void 0 : options.locusUrl);
    }

    /**
     * Set controls for this meeting.
     *
     * @param {Array<ControlConfig>} controls - Spread Array of ControlConfigs
     * @returns {Promise<Array<any>>}- Promise resolving if the request was successful.
     */
  }, {
    key: "update",
    value: function update() {
      var _this = this;
      for (var _len = arguments.length, controls = new Array(_len), _key = 0; _key < _len; _key++) {
        controls[_key] = arguments[_key];
      }
      var payloads = controls.map(function (control) {
        if (!(0, _keys.default)(_enums.Control).includes(control.scope)) {
          throw new Error("updating meeting control scope \"".concat(control.scope, "\" is not a supported scope"));
        }
        if (!_util.default.canUpdate(control, _this.displayHints)) {
          throw new _permission.default("updating meeting control scope \"".concat(control.scope, "\" not allowed, due to moderator property."));
        }
        return (0, _defineProperty2.default)({}, control.scope, control.properties);
      });
      return payloads.reduce(function (previous, payload) {
        return previous.then(function () {
          return (
            // @ts-ignore
            _this.request.request({
              uri: "".concat(_this.locusUrl, "/").concat(_constants.CONTROLS),
              body: payload,
              method: _constants.HTTP_VERBS.PATCH
            })
          );
        });
      }, _promise.default.resolve());
    }

    /**
     * @param {Setting} setting
     * @private
     * @memberof ControlsOptionsManager
     * @returns {Promise}
     */
  }, {
    key: "setControls",
    value: function setControls(setting) {
      var _this2 = this;
      _loggerProxy.default.logger.log("ControlsOptionsManager:index#setControls --> ".concat((0, _stringify.default)(setting)));
      var body = {};
      var error;
      var shouldSkipCheckToMergeBody = false;
      (0, _entries.default)(setting).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        if (!shouldSkipCheckToMergeBody && value !== undefined && !(_util.default !== null && _util.default !== void 0 && _util.default["".concat(value ? _constants2.CAN_SET : _constants2.CAN_UNSET).concat(key)](_this2.displayHints))) {
          error = new _permission.default("".concat(key, " [").concat(value, "] not allowed, due to moderator property."));
        }
        if (error) {
          return;
        }
        switch (key) {
          case _enums.Setting.muted:
            shouldSkipCheckToMergeBody = true;
            body.audio = body.audio ? _objectSpread(_objectSpread({}, body.audio), {}, (0, _defineProperty2.default)({}, (0, _lodash.camelCase)(key), value)) : (0, _defineProperty2.default)({}, (0, _lodash.camelCase)(key), value);
            break;
          case _enums.Setting.disallowUnmute:
          case _enums.Setting.muteOnEntry:
            if ((0, _keys.default)(setting).includes(_enums.Setting.muted)) {
              body.audio = body.audio ? _objectSpread(_objectSpread({}, body.audio), {}, (0, _defineProperty2.default)({}, (0, _lodash.camelCase)(key), value)) : (0, _defineProperty2.default)({}, (0, _lodash.camelCase)(key), value);
              body.audio[(0, _lodash.camelCase)(key)] = value;
            } else {
              body[(0, _lodash.camelCase)(key)] = (0, _defineProperty2.default)({}, _constants2.ENABLED, value);
            }
            break;
          case _enums.Setting.roles:
            if ((0, _isArray.default)(value)) {
              body.audio = body.audio ? _objectSpread(_objectSpread({}, body.audio), {}, (0, _defineProperty2.default)({}, (0, _lodash.camelCase)(key), value)) : (0, _defineProperty2.default)({}, (0, _lodash.camelCase)(key), value);
            }
            break;
          default:
            error = new _permission.default("".concat(key, " [").concat(value, "] not allowed, due to moderator property."));
        }
      });
      if (error) {
        return _promise.default.reject(error);
      }

      // @ts-ignore
      return this.request.request({
        uri: "".concat(this.locusUrl, "/").concat(_constants.CONTROLS),
        body: body,
        method: _constants.HTTP_VERBS.PATCH
      });
    }

    /**
     * @public
     * @param {boolean} enabled
     * @memberof ControlsOptionsManager
     * @returns {Promise}
     */
  }, {
    key: "setMuteOnEntry",
    value: function setMuteOnEntry(enabled) {
      return this.setControls((0, _defineProperty2.default)({}, _enums.Setting.muteOnEntry, enabled));
    }

    /**
     * @public
     * @param {boolean} enabled
     * @memberof ControlsOptionsManager
     * @returns {Promise}
     */
  }, {
    key: "setDisallowUnmute",
    value: function setDisallowUnmute(enabled) {
      return this.setControls((0, _defineProperty2.default)({}, _enums.Setting.disallowUnmute, enabled));
    }

    /**
     * @public
     * @param {boolean} mutedEnabled
     * @param {boolean} disallowUnmuteEnabled
     * @param {boolean} muteOnEntryEnabled
     * @param {array} roles which should be muted
     * @memberof ControlsOptionsManager
     * @returns {Promise}
     */
  }, {
    key: "setMuteAll",
    value: function setMuteAll(mutedEnabled, disallowUnmuteEnabled, muteOnEntryEnabled, roles) {
      return this.setControls((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _enums.Setting.muted, mutedEnabled), _enums.Setting.disallowUnmute, disallowUnmuteEnabled), _enums.Setting.muteOnEntry, muteOnEntryEnabled), _enums.Setting.roles, roles));
    }
  }]);
  return ControlsOptionsManager;
}();
//# sourceMappingURL=index.js.map
